



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'

import { Guest } from '@/types'

import Socket from '@/store/socket.ts'

const socketStore = getModule(Socket)

@Component
export default class SocketGuests extends Vue {
  debounceTimer: number = 0

  get otherGuests (): Guest[] {
    return socketStore.guests.filter(g => g.sId !== this.guest.sId)
  }
  get guest (): Guest {
    return socketStore.guest
  }
  get guestName (): string {
    return this.guest.name
  }
  set guestName (name: string) {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = window.setTimeout(() => {
      // Note how we use an arrow function to get access to the "this" object
      // See https://stackoverflow.com/a/38737108/7351594
      socketStore.updateGuest({ ...this.guest, name })
    }, 1000) // 1 second to be sure the socket update loop does not interfere
    // when the user types (and there is no urgency in propagating the name
    // update)
  }
}
